<div [@fadeInDown] class="content-area">
  <div class="not-found-message">
    <clr-icon shape="shield-x" size="36"></clr-icon>
    <h3>
      &nbsp;The requested page could not be found or you are not authorized to view it.
    </h3>
    <button routerLink="/" class="btn btn-br btn-no-caps m-2">Go To Dashboard</button>
  </div>
</div>
